import { Outlet } from 'react-location';
// @mui
import { styled } from '@mui/material/styles';
// components
import Logo from 'src/components/Logo';
import LogoutButton from 'src/components/LogoutButton';
// images
import FullLogo from 'src/assets/logo/logo_full.png';

// ----------------------------------------------------------------------

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0),
  },
  display: 'flex',
  justifyContent: 'space-between',
}));

// ----------------------------------------------------------------------

const LogoOnlyLayout: React.FC<{}> = ({ children }) => (
  <>
    <HeaderStyle>
      <Logo sx={{ width: 150 }} path={FullLogo} />
      <LogoutButton />
    </HeaderStyle>
    {children ? <>{children}</> : <Outlet />}
  </>
);

export default LogoOnlyLayout;
